export enum Size {
    S = 64,
    M = 128,
    L = 320,
}

export function useAvatar(expertId: string, size: Size) {
    return `https://avatars.99static.com/avatars/${expertId}/${size}`;
}
